export default "__VITE_ASSET__n3XS0EGZ__"